const COUNTRY_NAMES: Readonly<Record<string, string>> = {
  BG: 'Bulgaria',
  HR: 'Croatia',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  DE: 'Germany',
  IE: 'Ireland',
  LV: 'Latvia',
  LT: 'Lithuania',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  RS: 'Serbia',
  SK: 'Slovakia',
  ES: 'Spain',
  SE: 'Sweden',
  TR: 'Turkey',
  UA: 'Ukraine',
  GB: 'United Kingdom',
};

/** Human-readable presentation only. Engineering dataset selection still uses the ISO code. */
export function countryDisplayName(countryCode: string): string {
  const normalized = countryCode.trim().toUpperCase();
  if (normalized === '') return '';
  return COUNTRY_NAMES[normalized] ?? normalized;
}
